/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_PoInputs */

const en_scene_outside_po = /** @type {(inputs: Scene_Outside_PoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase order`)
};

/**
* | output |
* | --- |
* | "Purchase order" |
*
* @param {Scene_Outside_PoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_po = /** @type {((inputs?: Scene_Outside_PoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_PoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_po(inputs)
});